import { useEffect, useState } from 'react';
import { Logger } from '../utils';
import { useTwilioAppState } from '../state/';

export function useParticipantNetworkQualityLevel(participant, isLocalParticipant) {
    const [networkQualityLevel, setNetworkQualityLevel] = useState(
        participant && participant.networkQualityLevel ? participant.networkQualityLevel : null);
    const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        const handleNetworkQualityLevelChange = (networkQualityLevel, networkQualityStats) => {
            setNetworkQualityLevel(networkQualityLevel);
            const participantIdentity = participant && participant.identity ? participant.identity : "";
            const activityCode = isLocalParticipant ? "UI.Twilio.LocalParticipant.NetworkQualityLevel.Changed" : "UI.Twilio.RemoteParticipant.NetworkQualityLevel.Changed";
            Logger(activityCode, new Date(), { identity: participantIdentity, networkQualityLevel: networkQualityLevel, networkQualityStats: networkQualityStats });
        };
        if (_isMounted && _isMounted.current === true)
            setNetworkQualityLevel(participant && participant.networkQualityLevel ? participant.networkQualityLevel : null);       
        participant.on('networkQualityLevelChanged', handleNetworkQualityLevelChange);
        return () => {
            participant.off('networkQualityLevelChanged', handleNetworkQualityLevelChange);
        };
    }, [participant, _isMounted]);

    return networkQualityLevel;
}

export default function ParticipantNetworkQualityLevel({ setState, participant, isLocalParticipant }) {
    const networkQualityLevel = useParticipantNetworkQualityLevel(participant, isLocalParticipant);
    const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true)
        setState(networkQualityLevel);
    }, [networkQualityLevel, participant, _isMounted]);
    return null;
}
